import styles from 'css/admin/dashboard.module.css';

const UsageBar = ({ used = 45000, total = 50000 }) => {
    // 퍼센트 계산 (소수점 반올림)
    const usedPercent = Math.round((used / total) * 100);
    const remainingPercent = 100 - usedPercent;

    // 라벨이 좌우 끝에서 잘리지 않도록 위치 보정 (6% ~ 94% 사이로 고정)
    const clampedLabelPercent = Math.max(6, Math.min(usedPercent, 94));

    return (
        <div className={styles.container}>
            {/* 컨테이너 레벨 세로 마커: 0%, 분기점, 100% */}
            <div className={styles.vMarkerLongStart} />
            <div className={styles.vMarkerLong} style={{ left: `${usedPercent}%` }} />
            <div className={styles.vMarkerLongEnd} />
            {/* 상단 레이블 영역 */}
            <div className={styles.topLabels}>
                <span className={styles.labelStart}>0%</span>

                {/* 사용량 지점 표시 (동적 위치) */}
                <div
                    className={styles.labelCurrent}
                    style={{ left: `${clampedLabelPercent}%` }}
                >
                    {usedPercent}% ({used.toLocaleString()})
                </div>

                <span className={styles.labelEnd}>100%</span>
            </div>

            {/* 메인 바 영역 */}
            <div className={styles.barContainer}>
                <div
                    className={styles.barUsed}
                    style={{ width: `${usedPercent}%` }}
                />
                <div
                    className={styles.barRemaining}
                    style={{ width: `${remainingPercent}%` }}
                />
            </div>

            {/* 하단 설명(점선 및 텍스트) 영역 */}
            <div className={styles.bottomLegend}>
                {/* 사용중 구간 */}
                <div className={styles.legendItem} style={{ width: `${usedPercent}%` }}>
                    <span className={styles.legendText}>사용중</span>
                </div>

                {/* 잔여 구간 */}
                <div className={styles.legendItem} style={{ width: `${remainingPercent}%` }}>
                    <span className={styles.legendText}>잔여</span>
                </div>
            </div>
        </div>
    );
};

export default UsageBar;